import { BrokerService } from '@c4/core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { ProgrammingUtilsService } from './utils.service';
import { Event } from '../interfaces/event.interface';

export interface ProgrammingEventsState {
  ready: boolean;
  allEvents: Event[];
  programmedEvents: Event[];
}

const INITIAL_STATE: ProgrammingEventsState = {
  ready: false,
  allEvents: [],
  programmedEvents: []
};

const STORE_NAME: string = 'PROGRAMMING:EVENTS:';
const SET_ALL_EVENTS: string = STORE_NAME + 'SET_ALL_EVENTS';
const SET_PROGRAMMED_EVENTS: string = STORE_NAME + 'SET_PROGRAMMED_EVENTS';

export function programmingEventsReducer(state: ProgrammingEventsState = INITIAL_STATE, { type, payload }) {
  if (type.indexOf(STORE_NAME) > -1) {
    // console.debug('DEBUG >> %s called with %O', type, payload);
  }

  switch (type) {
    case SET_ALL_EVENTS: return Object.assign({}, state, { ready: true, allEvents: payload });
    case SET_PROGRAMMED_EVENTS: return Object.assign({}, state, { programmedEvents: payload });
  }

  return state;
}

@Injectable()
export class EventsService {

  ready: Observable<boolean>;
  allEvents: Observable<Event[]>;
  programmedEvents: Observable<Event[]>;

  constructor(
    private broker: BrokerService,
    private utils: ProgrammingUtilsService,
    private store: Store<{ programmingEvents: ProgrammingEventsState }>
  ) {
    this.allEvents = this.store.select(s => s.programmingEvents.allEvents);
    this.programmedEvents = this.store.select(s => s.programmingEvents.programmedEvents);
    this.ready = this.store.select(s => s.programmingEvents.ready);

    // this subscription is updated any time a new device is added to the project and is used
    // to re-evaluate automation capabilities
    this.broker.getObservable<Event[]>({
      path: '/api/v1/items/events',
      queryString: {
        allevents: true,
        fields: 'name,eventId,deviceId,display,deviceName,deviceRoomName,params'
      }
    })
    .filter(ev => !!ev && ev.length > 0)
    .subscribe(events => {
      this._handleAllEventsUpdates(events);
    });

    // this subscription only watches for changes to codeitems on events and us used to populate
    // lists of existing programming
    this.broker.getObservable<Event[]>({
      path: '/api/v1/items/events'
    })
    .filter(ev => !!ev && ev.length > 0)
    .subscribe(events => {
      this._handleProgrammedEventsUpdates(events);
    })

    // DEBUG
    // this.allEvents.subscribe(events => {
    //   console.log('roomdevice events', events.filter(evt => evt.display.indexOf('Hallway') > -1));
    // })
  }

  // NOTE we get all events back whenever anything changes
  private _handleAllEventsUpdates(updates: Event[]) {
    if (Array.isArray(updates)) {
      this.store.dispatch({ type: SET_ALL_EVENTS, payload: updates });
    }
  }

  private _handleProgrammedEventsUpdates(updates: Event[]) {
    if (Array.isArray(updates)) {
      // TODO should we add icons and other decorations here?
      this.store.dispatch({ type: SET_PROGRAMMED_EVENTS, payload: this.utils.resolveProtected(updates) });
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/services/events.service.ts